/* Keeps the free Brompton Pro Build tied to an actual Brompton bike.
   The Pro Build is auto-added by the ss-product-addons section on bike
   pages; this removes it from the cart when no Brompton bike is present
   and caps its quantity at the number of bikes in the cart (closes the
   "delete the bike, keep the freebie" and quantity-bump paths). */
(function () {
  var PRO_BUILD_HANDLE = 'brompton-pro-build';
  var busy = false;

  function isBike(item) {
    var pt = item.product_type || '';
    return item.vendor === 'Brompton' &&
      (pt.indexOf('Bikes') === 0 || pt.indexOf('Electric Bikes') === 0);
  }

  function check() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var pro = [];
        var bikeQty = 0;
        (cart.items || []).forEach(function (item) {
          if (item.handle === PRO_BUILD_HANDLE) pro.push(item);
          else if (isBike(item)) bikeQty += item.quantity;
        });
        var changes = [];
        var allowed = bikeQty;
        pro.forEach(function (item) {
          var want = Math.min(item.quantity, Math.max(allowed, 0));
          allowed -= want;
          if (want !== item.quantity) changes.push({ id: item.key, quantity: want });
        });
        if (!changes.length) { busy = false; return; }
        var chain = Promise.resolve();
        changes.forEach(function (c) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(c)
            });
          });
        });
        chain.then(function () {
          busy = false;
          if (location.pathname.indexOf('/cart') === 0) location.reload();
        }).catch(function () { busy = false; });
      })
      .catch(function () { busy = false; });
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var target = arguments[0];
    var url = target && (target.url || String(target)) || '';
    var result = origFetch.apply(this, arguments);
    if (!busy && /\/cart\/(add|change|update|clear)/.test(url)) {
      result.then(function () { setTimeout(check, 400); }, function () {});
    }
    return result;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }
})();
